import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import DiagnosticWizard from "@/components/site/DiagnosticWizard";

const Ctx = createContext(null);

export function DiagnosticProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState(null);
  const [presetSector, setPresetSector] = useState(null);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  const openDiagnostic = useCallback((sectorKey = null) => {
    setPresetSector(sectorKey);
    setOpen(true);
  }, []);

  return (
    <Ctx.Provider value={{ openDiagnostic }}>
      {children}
      <DiagnosticWizard open={open} onOpenChange={setOpen} content={content} presetSector={presetSector} />
    </Ctx.Provider>
  );
}

export const useDiagnostic = () => useContext(Ctx) || { openDiagnostic: () => {} };
